// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__DQ0vP","label":"Labeled_label__2yFl5","divider":"Labeled_divider__t8Hxl"};